module.exports = __webpack_public_path__ + "img/card1.87d8c053.png";